export async function fetchPublishedVersion(fetcher: typeof fetch = fetch, timeoutMs = 6_000): Promise<string> {
  const controller = new AbortController();
  const timer = globalThis.setTimeout(() => controller.abort(), timeoutMs);
  try {
    const response = await fetcher(`/version.json?check=${Date.now()}`, { cache: 'no-store', signal: controller.signal });
    if (!response.ok) throw new Error(`Version check failed (${response.status}).`);
    const value: unknown = await response.json();
    if (!value || typeof value !== 'object' || !('version' in value) || typeof value.version !== 'string' || !/^\d+\.\d+\.\d+$/.test(value.version)) throw new Error('Invalid version response.');
    return value.version;
  } finally { globalThis.clearTimeout(timer); }
}

export function withDeadline<T>(promise: Promise<T>, timeoutMs: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = globalThis.setTimeout(() => reject(new Error('Update check timed out.')), timeoutMs);
    promise.then(
      (value) => { globalThis.clearTimeout(timer); resolve(value); },
      (error) => { globalThis.clearTimeout(timer); reject(error); },
    );
  });
}
